export interface ColorSet {
  accent: string;
  a: string;
  b: string;
  mfill: string;
  mcell: string;
  /** combo grid fill */
  combo: string;
  /** blocked row of the combo grid */
  blocker: string;
}
export interface Preset extends ColorSet {
  id: 'neon' | 'ember' | 'violet' | 'mono';
}

export const presets: readonly Preset[] = [
  { id: 'neon', accent: '#2ee6d6', a: '#ffb02e', b: '#7c9cff', mfill: '#7c9cff', mcell: '#1b1f21', combo: '#5f7391', blocker: '#e5484d' },
  { id: 'ember', accent: '#ff8a3d', a: '#ffd166', b: '#6ee7ff', mfill: '#6ee7ff', mcell: '#221c18', combo: '#8a7d74', blocker: '#ff5c5c' },
  { id: 'violet', accent: '#b78bff', a: '#ff7ab6', b: '#5be3a4', mfill: '#5be3a4', mcell: '#1d1a24', combo: '#7a7396', blocker: '#ff6b8a' },
  { id: 'mono', accent: '#e9f7f5', a: '#9be7ff', b: '#ffd6a5', mfill: '#e9f7f5', mcell: '#1f2224', combo: '#7d8b93', blocker: '#ff7a7a' },
];

export const defaultColors: ColorSet = (({ accent, a, b, mfill, mcell, combo, blocker }) => ({ accent, a, b, mfill, mcell, combo, blocker }))(
  presets[0]!,
);
